import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react'
import React, { Fragment, useState } from 'react'
import { LocaleEnum } from '@systemeio/ui-frontend'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import useUser from 'shared/hooks/use-user'
import { getLoginUrl } from 'shared/utils/url-utils'
import { PUBLIC_LAYOUT_X_PADDING } from '../../constants/public-layout-constants'
import PublicLanguageSwitcher from '../../public-language-switcher'
import { topMenuItems } from '../constants/top-menu-items'
import PublicHeaderLoginIcon from '../icons/public-header-login-icon'
import NavLink from './nav-link'

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { user } = useUser()
  const { t } = useTranslation()
  const router = useRouter()
  const locale = router.locale as LocaleEnum

  return (
    <>
      <BurgerButton isOpen={isOpen} setIsOpen={setIsOpen} />
      <Transition show={isOpen} as={Fragment}>
        <Dialog
          className="fixed inset-0 z-10"
          onClose={value => {
            setIsOpen(value)
          }}
        >
          <TransitionChild
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/50" />
          </TransitionChild>

          <TransitionChild
            as={Fragment}
            enter="ease-out duration-500"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <DialogPanel>
              <div
                className={`fixed right-0 top-0 z-10 min-w-[17rem] gap-5 overflow-auto rounded-bl-lg bg-background-secondary pb-10 pt-[92px] text-text-primary ${PUBLIC_LAYOUT_X_PADDING} flex flex-col`}
              >
                <BurgerButton
                  className={'absolute right-[32px] top-[36px]'}
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                />
                {topMenuItems
                  .filter(item => !item.excludeLocales?.includes(locale))
                  .map((item, index) => (
                    <NavLink key={index} href={item.href}>
                      <div className={'flex items-center gap-1.5'}>
                        <div className={'min-w-[33px]'}>{item.icon}</div>
                        <span>{t(item.title)}</span>
                      </div>
                    </NavLink>
                  ))}
                <NavLink signInLink noLoco href={user ? '/dashboard' : getLoginUrl(locale)}>
                  <div className={'flex items-center gap-1.5'}>
                    <div className={'min-w-[33px]'}>
                      <PublicHeaderLoginIcon />
                    </div>
                    {user ? t('global.dashboard') : t('public.public_header.sing_in')}
                  </div>
                </NavLink>
                {/*{!user && (*/}
                {/*  <PublicButton className={'w-fit'} fontClassName={'font-mulish'}>*/}
                {/*    {t('public.public_header.get_my_free_account')}*/}
                {/*  </PublicButton>*/}
                {/*)}*/}
                <PublicLanguageSwitcher mobile />
              </div>
            </DialogPanel>
          </TransitionChild>
        </Dialog>
      </Transition>
    </>
  )
}

const GENERIC_HAMBURGER_LINE = `h-1 w-8 my-[3px] bg-brand-primary transition ease transform`

const BurgerButton = ({
  isOpen,
  setIsOpen,
  className,
}: {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  className?: string
}) => (
  <button
    className={`${
      className || ''
    } group col-end-7 flex size-[42px] flex-col items-center justify-center rounded outline-none ring-brand-primary focus-visible:ring-2 lg:hidden`}
    onClick={() => setIsOpen(!isOpen)}
  >
    <div
      className={`${GENERIC_HAMBURGER_LINE} duration-300 ${
        isOpen ? 'translate-y-2.5 rotate-45' : ''
      }`}
    />
    <div className={`${GENERIC_HAMBURGER_LINE} duration-300 ${isOpen ? 'opacity-0' : ''}`} />
    <div
      className={`${GENERIC_HAMBURGER_LINE} duration-300 ${
        isOpen ? '-translate-y-2.5 -rotate-45' : ''
      }`}
    />
  </button>
)
export default MobileMenu
